import * as requester from '../utils/requester';

export const createGiftChairRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: 'v1/gift-rsee',
        method: 'POST',
        data: reqObject,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};